module.exports = __webpack_public_path__ + "img/horizontal_4_7_pp2_1.2e3c8b29.png";